import script from "./CheckoutPickUpDeliverable.vue?vue&type=script&lang=ts&setup=true"
export * from "./CheckoutPickUpDeliverable.vue?vue&type=script&lang=ts&setup=true"

import "./CheckoutPickUpDeliverable.vue?vue&type=style&index=0&id=f8b15b94&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8b15b94"]])

export default __exports__